// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","532":"styles","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"64d88cbd294de6c66fd8","532":"8ae3b88db81cae6a9fff","691":"08a23b54cc9fe8c39b62"}[chunkId] + ".js";
};